var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.334 3H25V1C25 0.447 24.553 0 24 0C23.447 0 23 0.447 23 1V3H17V1C17 0.447 16.552 0 16 0C15.448 0 15 0.447 15 1V3H9V1C9 0.447 8.552 0 8 0C7.448 0 7 0.447 7 1V3H2.667C1.194 3 0 4.193 0 5.666V29.333C0 30.806 1.194 32 2.667 32H29.334C30.807 32 32 30.806 32 29.333V5.666C32 4.193 30.807 3 29.334 3ZM30 29.333C30 29.701 29.701 30 29.334 30H2.667C2.299 30 2 29.701 2 29.333V5.666C2 5.299 2.299 5 2.667 5H7V7C7 7.553 7.448 8 8 8C8.552 8 9 7.553 9 7V5H15V7C15 7.553 15.448 8 16 8C16.552 8 17 7.553 17 7V5H23V7C23 7.553 23.447 8 24 8C24.553 8 25 7.553 25 7V5H29.334C29.701 5 30 5.299 30 5.666V29.333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12H7V15H11V12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H7V20H11V17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22H7V25H11V22Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H14V25H18V22Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17H14V20H18V17Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H14V15H18V12Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22H21V25H25V22Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17H21V20H25V17Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12H21V15H25V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.193599d46df522d3f96df3a6e9c2c58b.svg";
export { ForwardRef as ReactComponent };